export default {"src":"/_next/static/media/wheel-position-en.778d8602.svg","height":1064,"width":1064,"blurWidth":0,"blurHeight":0};